import PageHeader from "../../../components/common/PageHeader";
import ClientForm from "../components/ClientForm";

const CreateClient = () => {
  return (
    <>
      <PageHeader
        title="Create Client"
        breadcrumbs={[
          { label: "Masters" },
          { label: "Client Master", path: "/masters/client" },
          { label: "Create Client" },
        ]}
      />

      <div className="container mt-4">
        <ClientForm />
      </div>
    </>
  );
};

export default CreateClient;
